import textContent from 'utils/DOM/textContent'
import store from 'utils/store/withMiddleware'

function updateRange(values) {
  const name = this.target.getAttribute('data-name')
  const [min, max] = values.map(val => +val.replace(/[^0-9.-]/g, ''))
  const { filters } = store.getState()

  textContent(`#${name}-range-min`, values[0])
  textContent(`#${name}-range-max`, values[1])
  filters[name].max = max
  filters[name].min = min
  store.update({ filters })
}

export default updateRange
